import React from 'react';
import { botNavbar } from '../../Data';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../UserContext/UserContext';
import { AppButtonLink } from '../AppButton/AppButton';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';

const Navbar = () => {
  const { showLogin } = useGlobalContext();

  return (
    <nav className='w-full sticky bg-white top-0 z-50'>
      {botNavbar?.map((elem, i) => (
        <ul className="bg-white text-gray-900 flex border-b border-blue-100 justify-around items-center" key={i}>
          <div className='flex justify-between ml-[2vw] items-center w-full max-w-[65vw]'>
            <Link to={"/"} className="flex items-center w-full max-w-[20vw] h-[6vw] no-underline" aria-label="NeuraTrader home">
              <figure className='w-full max-w-[30vw] rounded-full m-0'>
                <img src="/img/neuratrader_logo.png" alt="NeuraTrader" style={{ width: '160px', height: 'auto' }} />
              </figure>
            </Link>
            <div className="flex ml-[1vw] w-full items-center justify-evenly max-w-[50vw]">
              {elem.lists?.map((item, index) => (
                <Link to={item?.link} key={index} className="no-underline">
                  <li className='text-[1.5vw] xl:text-[0.8vw] text-slate-700 hover:text-blue-700 cursor-pointer lg:text-[0.8vw] list-none'>{item.title}</li>
                </Link>
              ))}
            </div>
          </div>
          {showLogin ? (
            <div className="app-nav-actions">
              <AppButtonLink to="/login" variant="secondary" size="nav">
                Sign In
              </AppButtonLink>
              <AppButtonLink to="/register" variant="primary" size="nav">
                Sign Up
              </AppButtonLink>
            </div>
          ) : (
            <div className="app-nav-actions app-nav-actions--profile">
              <UserProfileMenu variant="navbar" showDashboardLink />
            </div>
          )}
        </ul>
      ))}
    </nav>
  );
};

export default Navbar;